export default "__VITE_ASSET__D03t5KEH__"